import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { exchangeCodeForAccessToken } from '../api/shopify';
import { useAuth } from '../hooks/auth';

function CallbackPage() {
  const location = useLocation();
  const { user } = useAuth(); 
  const [isLoading, setIsLoading] = useState(true);
  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');

    // Vérifier si le code existe et si l'utilisateur est disponible
    if (code && user) {
      const userId = user.uid;

      exchangeCodeForAccessToken(code, userId)
        .then((accessToken) => {


          setAccessToken(accessToken);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Error exchanging code for access token:', error);
          setIsLoading(false);
          // Gérer les erreurs d'échange de code ici
        });
    } else if (!code) {
      console.error('Code not found in URL.');
      setIsLoading(false);

    }
  }, [location, user]);


  return (
    <div>
      {isLoading ? (
        <h1>Loading...</h1>
      ) : (
        <div>
          <h1>Access Token Obtained!</h1>
          <p>Access Token: {accessToken}</p>
        </div>
      )}
    </div>
  );
}

export default CallbackPage;
